// extracted by mini-css-extract-plugin
module.exports = {"tag":"Tag-module__tag"};